export default "__VITE_ASSET__sM$rLn4W__"